import { ComponentsOverrides, Theme } from '@mui/material';

export const getMuiCardOverrides = (theme: Theme): ComponentsOverrides['MuiCard'] => ({
  root: {
    background: theme.themeColors.colorCardBackground,
    borderRadius: '24px',
    boxShadow: 'none',
    padding: '16px',
  },
});
